module.exports = __webpack_public_path__ + "static/media/3d-space-2.ad0f7a04.png";